import * as angular from "angular";
import {IController} from "angular";

export class AgentCreateButtonCtrl implements IController {

  onClick: Function;

  constructor() {
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentCreateButton', {
    bindings: {
      onClick: '&'
    },
    template: require('./agent-create-button.html').default,
    controller: AgentCreateButtonCtrl
  });
